<dialog [id]="modalDialogId" class="modal">
  <div class="modal-box max-w-[60vw] p-0 bg-transparent shadow-none overflow-hidden">
    <div class="flex justify-center items-center h-[720px] overflow-hidden">
      <div id="calendly-embed" class="w-[1000px] max-w-[90vw] h-[720px] overflow-hidden"></div>
    </div>
  </div>

  <form method="dialog" class="modal-backdrop">
    <button (click)="closeModal()">Close</button>
  </form>
</dialog>